{
  "frozen-columns-onboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Sort, freeze and resize Work from a single control."
    }
  ],
  "frozen-columns-onboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "frozen-columns-onboarding.spotlight.heading": [
    {
      "type": 0,
      "value": "Manage Work"
    }
  ],
  "jira-nin-group-by-any-field-changeboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Group work by fields including versions, labels, work types and more."
    }
  ],
  "jira-nin-group-by-any-field-changeboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-nin-group-by-any-field-changeboarding.spotlight.heading": [
    {
      "type": 0,
      "value": "Group work to stay organized"
    }
  ],
  "timeline-10k-issues-flag.actions-non-final": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "timeline-10k-issues-flag.description-non-final": [
    {
      "type": 0,
      "value": "You cannot view rollups because the timeline has 10,000 or more issues."
    }
  ],
  "timeline-10k-issues-flag.title-non-final": [
    {
      "type": 0,
      "value": "You cannot view rollups because the timeline has 10,000 or more issues."
    }
  ],
  "timeline-feedback-collector.spotlight.body": [
    {
      "type": 0,
      "value": "In doing this we are keen to hear feedback from users about the timeline, what else you may want, and importantly, what you don’t want."
    }
  ],
  "timeline-feedback-collector.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "timeline-feedback-collector.spotlight.give-feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "timeline-feedback-collector.spotlight.heading": [
    {
      "type": 0,
      "value": "We’re updating Jira timelines"
    }
  ]
}